import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconOwlFace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconOwlFace"><Path d="M12 12C12 9.37665 9.87335 7.25 7.25 7.25C4.62665 7.25 2.5 9.37665 2.5 12" stroke="currentColor"/><Path d="M21.5 12C21.5 9.37665 19.3734 7.25 16.75 7.25C14.1266 7.25 12 9.37665 12 12" stroke="currentColor"/><Circle cx="7.5" cy="12" r="1.25" fill="currentColor"/><Circle cx="16.5" cy="12" r="1.25" fill="currentColor"/><Path d="M12 12V15" stroke="currentColor" strokeLinejoin="round"/><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconOwlFace;
